import { Component } from 'react';
import PropTypes from 'prop-types';
import { Col } from '@platform/base';
import CompMeta from '../../meta/LowCodeComponents/Col';
const columnEnum = ['', 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

/**
 * @class NCCol
 * @column 1
 * @compType 1
 * @canAppend true
 * @path LowCodeComponents.NCCol
 * @label 列容器
 *
 */
class NCCol extends Component {
    constructor(props) {
        super(props);
    }
    static propTypes = {
        /**
        * @title 区域编码
        * @description 组件标识
        */
        moduleId: PropTypes.string.isRequired,
        /**
         * @title xs
         * @description 显示列数
         * @enumNames ['', 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
         */
        xs: PropTypes.oneOf(columnEnum),
        /**
         * @title sm
         * @description 显示列数
         */
        sm: PropTypes.oneOf(columnEnum),
        /**
         * @title md
         * @description 显示列数
         */
        md: PropTypes.oneOf(columnEnum),
        /**
         * @title lg
         * @description 显示列数
         */
        lg: PropTypes.oneOf(columnEnum),
        /**
         * @title xsPull
         * @description 移动屏幕设备到右边距列数
         */
        xsPull: PropTypes.oneOf(columnEnum),
        /**
        * @title smPull
        * @description 小屏幕设备到右边距列数
        */
        smPull: PropTypes.oneOf(columnEnum),
        /**
       * @title mdPull
       * @description 中等屏幕设备到右边距列数
       */
        mdPull: PropTypes.oneOf(columnEnum),
        /**
        * @title lgPull
        * @description 大屏幕设备到右边距列数
        */
        lgPull: PropTypes.oneOf(columnEnum),
        /**
       * @title xsPush
       * @description 移动屏幕设备到左边距列数
       */
        xsPush: PropTypes.oneOf(columnEnum),
        /**
        * @title smPush
        * @description 小屏幕设备到左边距列数
        */
        smPush: PropTypes.oneOf(columnEnum),
        /**
       * @title mdPush
       * @description 中等屏幕设备到左边距列数
       */
        mdPush: PropTypes.oneOf(columnEnum),
        /**
        * @title lgPush
        * @description 大屏幕设备到左边距列数
        */
        lgPush: PropTypes.oneOf(columnEnum),
        /**
       * @title xsOffset
       * @description 移动屏幕设备偏移列数
       */
        xsOffset: PropTypes.oneOf(columnEnum),
        /**
        * @title smOffset
        * @description 小屏幕设备偏移列数
        */
        smOffset: PropTypes.oneOf(columnEnum),
        /**
       * @title mdOffset
       * @description 中等屏幕设备偏移列数
       */
        mdOffset: PropTypes.oneOf(columnEnum),
        /**
        * @title lgOffset
        * @description 大屏幕设备偏移列数
        */
        lgOffset: PropTypes.oneOf(columnEnum),
    }
    static defaultProps = {
        xs: 6,
        sm: 6,
        md: 6,
        lg: 6
    }
    static getCompMeta = () => {
        return CompMeta;
    }
    componentDidMount() { }
    componentWillUnmount() { }
    render() {
        return (
            <Col {...this.props} className="lc-drop-area">
                {this.props.children}
            </Col>
        )
    }
}
export default NCCol;
